import { MouseEvent } from "react"
import { Button, Card, Stack, Typography, useMediaQuery } from "@mui/material"
import { CardInfo, StackButtons, TypStatictic } from "./style"
import { PureLightTheme } from "../../../styles/theme"
import { useNavigate } from "react-router-dom"
import { routesProfile } from "../../../consts"
import modalEmitter from "../../ModalComponent/modalEmitter"
import { JoinTeamModalBody, TeamMembersModalBody, openLeaveTeamModal } from "../../Modals"
import { ProjectTeamSection } from "../../ProjectPage/ProjectTeamSection"
import { TeamSubscribeButton } from "../../Teams/TeamSubscribeButton"
import { TeamProjectInvitationsSection } from "../TeamProjectInvitationsSection"
import type { TeamDescription } from "../../../types/entitys/teams"

type TeamInfoSideProps = {
  team: Pick<
    TeamDescription,
    | 'id'
    | 'participants'
    | 'subscribers'
    | 'views'
    | 'isOwner'
    | 'canEditContent'
    | 'canRespondInvitations'
    | 'isSubscribed'
    | 'isJoined'
    | 'hasPendingJoinRequest'
    | 'membersPreview'
  >
}

export const TeamInfo = ({ team }: TeamInfoSideProps) => {
    const navigate = useNavigate()
    const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'));
    const canEdit = team.canEditContent === true;
    const isAdmin = canEdit && team.isOwner !== true;
    const canRespondInvitations = team.canRespondInvitations === true;
    const membersPreview = (team.membersPreview ?? []).slice(0, 5)
    const membersCount = Number(team.participants ?? 0)

    const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        navigate(`/${routesProfile.TEAMS.path}/${team.id}/edit`)
    }

    const openMembersModal = () => {
        modalEmitter.emitOpenModal({
            dialog: {
                title: 'Вся команда',
                body: <TeamMembersModalBody teamId={team.id} />,
                modalToCentrPosition: true,
            },
            closeAtion: { visible: false },
            confirmAtion: { visible: false },
        })
    }

    const handleLeaveTeam = () => {
        openLeaveTeamModal(team.id)
    }

    const handleJoinTeam = () => {
        modalEmitter.emitOpenModal({
            dialog: {
                title: "Присоединиться к команде",
                body: <JoinTeamModalBody teamId={team.id} />,
            },
            closeAtion: { visible: false },
            confirmAtion: { visible: false },
        })
    }

    return (
        <Card variant="primaryAdaptiveCard" sx={CardInfo}>
            <Stack direction="column" gap={{ xs: 1.5, sm: 2 }}>
                <Typography variant="h3">Статистика команды</Typography>
                <Stack direction="column" gap={{ xs: 0.5, md: 1 }}>
                    <Typography variant="h4" sx={TypStatictic}>Подписчиков: {team.subscribers}</Typography>
                    <Typography variant="h4" sx={TypStatictic}>Просмотров: {team.views}</Typography>
                </Stack>
                {membersCount > 0 && (
                    <ProjectTeamSection
                        members={membersPreview}
                        membersTotal={membersCount}
                        onOpenAllMembers={openMembersModal}
                        entity="team"
                    />
                )}
                {canEdit && !isAdmin && (
                    <Button variant="follow" onClick={handleEdit}>
                        Редактировать
                    </Button>
                )}
                {isAdmin && (
                    <Stack direction="column" gap={1} alignItems="flex-start" sx={StackButtons}>
                        <Button variant="follow" onClick={handleEdit}>
                            Редактировать
                        </Button>
                        <TeamSubscribeButton
                            teamId={team.id}
                            isSubscribed={team.isSubscribed}
                        />
                        {team.isJoined && (
                            <Button variant="danger" onClick={handleLeaveTeam}>
                                {isMobile ? 'Выйти' : 'Выйти из команды'}
                            </Button>
                        )}
                    </Stack>
                )}
                {!canEdit && (
                    <Stack direction="column" gap={1} alignItems="flex-start" sx={StackButtons}>
                    <TeamSubscribeButton
                        teamId={team.id}
                        isSubscribed={team.isSubscribed}
                    />
                    {team.isJoined ? (
                        <Button variant="danger" onClick={handleLeaveTeam}>
                            {isMobile ? 'Выйти' : 'Выйти из команды'}
                        </Button>
                    ) : team.hasPendingJoinRequest ? (
                        <Button variant="action" disabled>
                            {isMobile ? 'На рассмотрении' : 'Заявка на рассмотрении'}
                        </Button>
                    ) : (
                        <Button variant="action" onClick={handleJoinTeam}>
                            {isMobile ? 'Присоединиться' : 'Присоединиться к команде'}
                        </Button>
                    )}
                    </Stack>
                )}
                {canRespondInvitations && <TeamProjectInvitationsSection teamId={team.id} />}
            </Stack>
        </Card>
    )
}
